<template>
    <div id="all">
        <main id="main" class="has-nav">
            <div class="container">

                <div class="title-wrapper requests">
                    <h1 class="title line">Booking Requests</h1>
                    <div class="buttons-box">
                        <a href="#" class="btn light-green" @click.prevent="exportReq">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-exel/></icon-base>
                            <span>Export to XLS</span>
                        </a>
                    </div>
                </div>


                <div class="booling-box">
                    <tabs-component :tabs="tabs" :components="components"/>
                </div>


            </div>
        </main>
    </div>
</template>

<script>
import {mapMutations, mapActions/* mapState*/} from "vuex"
import {markRaw} from "vue"
import CurrentRequests from "./Requests/CurrentRequests"
import PastAndCanceledRequests from "./Requests/PastAndCanceledRequests"

import TabsComponent from "../Tabs";
import IconBase from "../common/IconBase";
import IconExel from "../common/icons/IconExel";
import SaveDialogRange from "../common/SaveDialogRange"

const components = markRaw({
    CurrentRequests, PastAndCanceledRequests
});

export default {
    name: 'requests',

    components: {IconExel, IconBase, TabsComponent},

    data() {
        return {
            components,

            tabs: [
                {
                    title: "Current",
                    class: 'email-settings-box'
                },
                {
                    title: "Past and Canceled",
                    class: 'lx-settings-box'
                }

            ]
        }
    },

    computed: {

    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapActions('requests', [
            'exportRequests',
            'loadRequests'
        ]),

        exportReq() {
            this.setPopupComponent(SaveDialogRange);
            this.setPopupData({func: this.exportRequests });
            this.switchPopup(true);
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
